import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imCustomFieldsFilters', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/filters/custom-fields-filters/custom-fields-filters.html'),
        controller: 'CustomFieldsFiltersController',
        controllerAs: 'CustomFieldsFiltersCtrl',
        bindings: {
            customFieldFilters: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/filters/custom-fields-filters/custom-fields-filters.component.ts